var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6569_20726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6569_20726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9789 20.5964L6.38281 14.0003L12.9789 7.4043L14.2082 8.63367L8.85965 14.0003L14.2082 19.367L12.9789 20.5964ZM20.3872 20.5964L13.7911 14.0003L20.3872 7.4043L21.6166 8.63367L16.268 14.0003L21.6166 19.367L20.3872 20.5964Z",
    fill: "#878A93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldIcon);
export default __webpack_public_path__ + "static/media/fold-icon.82d155d702cd14a1932996eb18d5f3bc.svg";
export { ForwardRef as ReactComponent };